import { Tooltip } from 'bootstrap';
import { DateTime } from "luxon";
import './parts/animations.js';
import anime from 'animejs/lib/anime.es.js';

jQuery(function ($) {
  var now = DateTime.now();
  var lastMonth = now.minus({ month: 1 });

  $(".wp-block-latest-posts__post-date").wrap(function () {
    return "<div class='wp-block-post-date'></div>";
  });

  $('.wp-block-post-date time, .comment-metadata time').each(function () {
    var datetimeAttr = $(this).attr('datetime');
    var datetimeText = $(this).html();

    if (datetimeAttr) {
      var date = DateTime.fromISO(datetimeAttr).setLocale(sowmedia.locale);

      if (date > lastMonth) {
        $(this).after('<span class="since" data-bs-toggle="tooltip" title="' + datetimeText + '">' + date.toRelative() + '</span>');
        $(this).addClass('visually-hidden');
      }
    }
  });

  // Trigger al tooltips
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
  });

  $("p.is-style-badge").wrap("<div></div>");

  // $('button[data-bs-target="#header-offcanvas-nav"]').on('click', function () {
  //   $('#header-offcanvas-nav .wp-block-search__input').focus();
  // });


});


document.querySelectorAll('#header-nav .dropdown').forEach(function(dropdown) {
  dropdown.addEventListener('mouseenter', function() {
    if (!dropdown.classList.contains('show')) {
      dropdown.classList.add('show');
      dropdown.querySelector('.dropdown-menu').classList.add('show');
    }
  });
  dropdown.addEventListener('mouseleave', function() {
    if (dropdown.classList.contains('show')) {
      dropdown.classList.remove('show');
      dropdown.querySelector('.dropdown-menu').classList.remove('show');
    }
  });
});

document.querySelectorAll('.has-stretched-link').forEach((item, i) => {

  var parents = ['wp-block-cover', 'wp-block-column'];

  for (var i = 0; i < parents.length; i++) {
    if (item.parentNode.classList.contains(parents[i])) {
      item.parentNode.classList.add('is-style-linked');
    }
    if (item.parentNode.parentNode.classList.contains(parents[i])) {
      item.parentNode.parentNode.classList.add('is-style-linked');
    }
  }

});

// For each FAQ block
document.querySelectorAll('.schema-faq').forEach((faq, i) => {

  // For each FAQ item within block
  faq.querySelectorAll('.schema-faq-section').forEach((item, j) => {

    // On click on question
    item.querySelector('.schema-faq-question').onclick = () => {

      // Add active class
      item.classList.toggle('schema-faq-section--active');

    };

  });

});


document.querySelectorAll('.toggle-comments').forEach((item, i) => {
  item.onclick = () => {
    document.querySelector('.comments-wrapper').style.display = 'block';
    if (item.classList.contains('go-to-comment-form')) {
      document.getElementById('#respond').scrollIntoView({ behavior: 'smooth' });
    }
  };
});

document.querySelectorAll('ul.is-style-leaf li').forEach((li, i) => {
  var leaf = '<svg width="14" height="17" xmlns="http://www.w3.org/2000/svg"><path d="m1.313 16.184.071-.102c.143-.204.295-.414.452-.609l.095-.115c.047-.055.136-.123.257-.204l.132-.085.322-.196.49-.294.217-.133.342-.215.117-.076.238-.158c.32-.217.648-.457.963-.72a8.75 8.75 0 0 0 .374-.349l.204-.206a19.734 19.734 0 0 0 2.068-2.567l.15-.225.22-.339.216-.339.209-.335.2-.33.253-.425.288-.499.343-.612.227-.42.174-.334.05-.102.01-.025.001-.005c.004-.025-.003-.03-.02-.018l-.026.023-.058.063-.079.096-.622.797-.246.307-.134.161-.14.167-.22.256-.234.263-.163.177-.167.177-.173.176-.176.175-.182.174-.193.178-.217.196-.358.316-.386.335-.267.23-.41.345-.41.34-.4.327-.255.205-.243.192-.227.176-.209.158-.187.136-.162.113a4.326 4.326 0 0 1-.07.047c-.328.218-.655.574-.928.92l-.122.158-.113.153-.103.146-.092.135-.113.175-.101.164-.026.045-.057.11-.13.295-.023.043a.498.498 0 0 1-.011.02l-.023.031c-.048.059-.098.05-.17-.08l-.033-.068-.038-.087-.04-.107-.07-.199-.052-.16-.054-.176C.586 12.496.326 10.588.63 8.94 1.14 6.17 3.958 3.399 6.648 2.48l.14-.045a9.57 9.57 0 0 1 1.517-.39l.096-.013.19-.023.184-.019.259-.022.496-.035.06-.006a.19.19 0 0 0 .018-.004c.041 0 .107-.007.184-.017l.162-.025.165-.03.197-.038.04-.01c.24-.059.355-.11.501-.19l.217-.124.093-.051.08-.046.155-.092.15-.093.342-.218.125-.077c.343-.204.6-.292.753-.038.678 1.188.942 4.284.507 6.895l-.03.173c-.26 1.605-.911 3.036-1.388 3.773-1.865 2.862-4.9 4.38-8.022 3.6-.368-.098-.797.212-1.22.634l-.14.145-.14.15-.139.154-.28.32-.607-.535Z" fill="#3D88CC" fill-rule="evenodd"/></svg>';
  li.innerHTML = leaf + li.innerHTML;
});

// Mega Menu
document.addEventListener("DOMContentLoaded", () => {
  const SELECTOR_MENU_ITEM = ".has-mega-menu";
  const DROPDOWN_SELECTOR = ".mega-menu-dropdown";
  const OPEN_CLASS = "is-mega-open";
  const margin = 10;

  const PREFERRED_COLUMN_SELECTOR =
    ".menu-megamenu-kolom-1-container, .wp-block-columns .wp-block-column:first-child";

  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  const getScrollbarWidth = () =>
    window.innerWidth - document.documentElement.clientWidth;

  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

  const menus = Array.from(document.querySelectorAll(SELECTOR_MENU_ITEM));
  if (!menus.length) return;

  const closeAll = () => {
    menus.forEach((m) => m.classList.remove(OPEN_CLASS));
  };

  const positionDropdown = (parent) => {
    const dropdown = parent.querySelector(DROPDOWN_SELECTOR);
    if (!dropdown) return;

    const prevDisplay = dropdown.style.display;
    const prevOpacity = dropdown.style.opacity;
    const prevVisibility = dropdown.style.visibility;

    dropdown.style.opacity = "0";
    dropdown.style.visibility = "hidden";
    dropdown.style.display = "block";

    const parentRect = parent.getBoundingClientRect();
    const menuRect = dropdown.getBoundingClientRect();

    const top = parentRect.bottom;
    const parentCenter = parentRect.left + parentRect.width / 2;

    const scrollbar = getScrollbarWidth();
    const minLeft = margin;
    const maxLeft = window.innerWidth - scrollbar - menuRect.width - margin;

    const leftCentered = parentCenter - menuRect.width / 2;

    let leftPreferred = null;
    const preferredEl = dropdown.querySelector(PREFERRED_COLUMN_SELECTOR);

    if (preferredEl) {
      const preferredRect = preferredEl.getBoundingClientRect();

      const preferredOffsetLeft = preferredRect.left - menuRect.left;
      const preferredCenterWithinMenu =
        preferredOffsetLeft + preferredRect.width / 2;

      leftPreferred = parentCenter - preferredCenterWithinMenu;
    }

    let left;
    if (
      leftPreferred !== null &&
      leftPreferred >= minLeft &&
      leftPreferred <= maxLeft
    ) {
      left = leftPreferred;
    } else {
      left = clamp(leftCentered, minLeft, maxLeft);
    }

    // Arrow position
    let arrowLeft = parentCenter - left;

    const minArrow = 20;
    const maxArrow = menuRect.width - 20;
    arrowLeft = clamp(arrowLeft, minArrow, maxArrow);

    dropdown.style.setProperty("--mega-top", `${top}px`);
    dropdown.style.setProperty("--mega-left", `${left}px`);
    dropdown.style.setProperty("--mega-arrow-left", `${arrowLeft}px`);

    // Restore inline styles
    dropdown.style.display = prevDisplay;
    dropdown.style.opacity = prevOpacity;
    dropdown.style.visibility = prevVisibility;
  };

  const openMenu = (menuEl) => {
    closeAll();
    positionDropdown(menuEl);
    menuEl.classList.add(OPEN_CLASS);
  };

  menus.forEach((menuEl) => {
    menuEl.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;
      openMenu(menuEl);
    });

    menuEl.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;
      menuEl.classList.remove(OPEN_CLASS);
    });

    menuEl.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link && menuEl.classList.contains(OPEN_CLASS)) {
        menuEl.classList.remove(OPEN_CLASS);
      }
    });
  });

  // Close on scroll (debounced)
  let scrollTimeout = null;
  window.addEventListener(
    "scroll",
    () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(closeAll, 50);
    },
    { passive: true }
  );

  // Click outside
  document.addEventListener("click", (e) => {
    const inside = menus.some((menuEl) => menuEl.contains(e.target));
    if (!inside) closeAll();
  });

  // Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  // Resize: close all
  window.addEventListener("resize", () => {
    closeAll();
  });
});
